// SPDX-License-Identifier: MIT
export const WORDLIST = [
    'abaco',
    'abbaglio',
    'abbinato',
    'abete',
    'abisso',
    'abolire',
    'abrasivo',
    'abrogato',
    'accadere',
    'accenno',
    'accusato',
    'acetone',
    'achille',
    'acido',
    'acqua',
    'acre',
    'acrilico',
    'acrobata',
    'acuto',
    'adagio',
    'addebito',
    'addome',
    'adeguato',
    'aderire',
    'adipe',
    'adottare',
    'adulare',
    'affabile',
    'affetto',
    'affisso',
    'affranto',
    'aforisma',
    'afoso',
    'africano',
    'agave',
    'agente',
    'agevole',
    'aggancio',
    'agire',
    'agitare',
    'agonismo',
    'agricolo',
    'agrumeto',
    'aguzzo',
    'alabarda',
    'alato',
    'albatro',
    'alberato',
    'albo',
    'albume',
    'alce',
    'alcolico',
    'alettone',
    'alfa',
    'algebra',
    'aliante',
    'alibi',
    'alimento',
    'allagato',
    'allegro',
    'allievo',
    'allodola',
    'allusivo',
    'almeno',
    'alogeno',
    'alpaca',
    'alpestre',
    'altalena',
    'alterno',
    'alticcio',
    'altrove',
    'alunno',
    'alveolo',
    'alzare',
    'amalgama',
    'amanita',
    'amarena',
    'ambito',
    'ambrato',
    'ameba',
    'america',
    'ametista',
    'amico',
    'ammasso',
    'ammenda',
    'ammirare',
    'ammonito',
    'amore',
    'ampio',
    'ampliare',
    'amuleto',
    'anacardo',
    'anagrafe',
    'analista',
    'anarchia',
    'anatra',
    'anca',
    'ancella',
    'ancora',
    'andare',
    'andrea',
    'anello',
    'angelo',
    'angolare',
    'angusto',
    'anima',
    'annegare',
    'annidato',
    'anno',
    'annuncio',
    'anonimo',
    'anticipo',
    'anzi',
    'apatico',
    'apertura',
    'apode',
    'apparire',
    'appetito',
    'appoggio',
    'approdo',
    'appunto',
    'aprile',
    'arabica',
    'arachide',
    'aragosta',
    'araldica',
    'arancio',
    'aratura',
    'arazzo',
    'arbitro',
    'archivio',
    'ardito',
    'arenile',
    'argento',
    'argine',
    'arguto',
    'aria',
    'armonia',
    'arnese',
    'arredato',
    'arringa',
    'arrosto',
    'arsenico',
    'arso',
    'artefice',
    'arzillo',
    'asciutto',
    'ascolto',
    'asepsi',
    'asettico',
    'asfalto',
    'asino',
    'asola',
    'aspirato',
    'aspro',
    'assaggio',
    'asse',
    'assoluto',
    'assurdo',
    'asta',
    'astenuto',
    'astice',
    'astratto',
    'atavico',
    'ateismo',
    'atomico',
    'atono',
    'attesa',
    'attivare',
    'attorno',
    'attrito',
    'attuale',
    'ausilio',
    'austria',
    'autista',
    'autonomo',
    'autunno',
    'avanzato',
    'avere',
    'avvenire',
    'avviso',
    'avvolgere',
    'azione',
    'azoto',
    'azzimo',
    'azzurro',
    'babele',
    'baccano',
    'bacino',
    'baco',
    'badessa',
    'badilata',
    'bagnato',
    'baita',
    'balcone',
    'baldo',
    'balena',
    'ballata',
    'balzano',
    'bambino',
    'bandire',
    'baraonda',
    'barbaro',
    'barca',
    'baritono',
    'barlume',
    'barocco',
    'basilico',
    'basso',
    'batosta',
    'battuto',
    'baule',
    'bava',
    'bavosa',
    'becco',
    'beffa',
    'belgio',
    'belva',
    'benda',
    'benevole',
    'benigno',
    'benzina',
    'bere',
    'berlina',
    'beta',
    'bibita',
    'bici',
    'bidone',
    'bifido',
    'biga',
    'bilancia',
    'bimbo',
    'binocolo',
    'biologo',
    'bipede',
    'bipolare',
    'birbante',
    'birra',
    'biscotto',
    'bisesto',
    'bisnonno',
    'bisonte',
    'bisturi',
    'bizzarro',
    'blando',
    'blatta',
    'bollito',
    'bonifico',
    'bordo',
    'bosco',
    'botanico',
    'bottino',
    'bozzolo',
    'braccio',
    'bradipo',
    'brama',
    'branca',
    'bravura',
    'bretella',
    'brevetto',
    'brezza',
    'briglia',
    'brillante',
    'brindare',
    'broccolo',
    'brodo',
    'bronzina',
    'brullo',
    'bruno',
    'bubbone',
    'buca',
    'budino',
    'buffone',
    'buio',
    'bulbo',
    'buono',
    'burlone',
    'burrasca',
    'bussola',
    'busta',
    'cadetto',
    'caduco',
    'calamaro',
    'calcolo',
    'calesse',
    'calibro',
    'calmo',
    'caloria',
    'cambusa',
    'camerata',
    'camicia',
    'cammino',
    'camola',
    'campale',
    'canapa',
    'candela',
    'cane',
    'canino',
    'canotto',
    'cantina',
    'capace',
    'capello',
    'capitolo',
    'capogiro',
    'cappero',
    'capra',
    'capsula',
    'carapace',
    'carcassa',
    'cardo',
    'carisma',
    'carovana',
    'carretto',
    'cartolina',
    'casaccio',
    'cascata',
    'caserma',
    'caso',
    'cassone',
    'castello',
    'casuale',
    'catasta',
    'catena',
    'catrame',
    'cauto',
    'cavillo',
    'cedibile',
    'cedrata',
    'cefalo',
    'celebre',
    'cellulare',
    'cena',
    'cenone',
    'centesimo',
    'ceramica',
    'cercare',
    'certo',
    'cerume',
    'cervello',
    'cesoia',
    'cespo',
    'ceto',
    'chela',
    'chiaro',
    'chicca',
    'chiedere',
    'chimera',
    'china',
    'chirurgo',
    'chitarra',
    'ciao',
    'ciclismo',
    'cifrare',
    'cigno',
    'cilindro',
    'ciottolo',
    'circa',
    'cirrosi',
    'citrico',
    'cittadino',
    'ciuffo',
    'civetta',
    'civile',
    'classico',
    'clinica',
    'cloro',
    'cocco',
    'codardo',
    'codice',
    'coerente',
    'cognome',
    'collare',
    'colmato',
    'colore',
    'colposo',
    'coltivato',
    'colza',
    'coma',
    'cometa',
    'commando',
    'comodo',
    'computer',
    'comune',
    'conciso',
    'condurre',
    'conferma',
    'congelare',
    'coniuge',
    'connesso',
    'conoscere',
    'consumo',
    'continuo',
    'convegno',
    'coperto',
    'copione',
    'coppia',
    'copricapo',
    'corazza',
    'cordata',
    'coricato',
    'cornice',
    'corolla',
    'corpo',
    'corredo',
    'corsia',
    'cortese',
    'cosmico',
    'costante',
    'cottura',
    'covato',
    'cratere',
    'cravatta',
    'creato',
    'credere',
    'cremoso',
    'crescita',
    'creta',
    'criceto',
    'crinale',
    'crisi',
    'critico',
    'croce',
    'cronaca',
    'crostata',
    'cruciale',
    'crusca',
    'cucire',
    'cuculo',
    'cugino',
    'cullato',
    'cupola',
    'curatore',
    'cursore',
    'curvo',
    'cuscino',
    'custode',
    'dado',
    'daino',
    'dalmata',
    'damerino',
    'daniela',
    'dannoso',
    'danzare',
    'datato',
    'davanti',
    'davvero',
    'debutto',
    'decennio',
    'deciso',
    'declino',
    'decollo',
    'decreto',
    'dedicato',
    'definito',
    'deforme',
    'degno',
    'delegare',
    'delfino',
    'delirio',
    'delta',
    'demenza',
    'denotato',
    'dentro',
    'deposito',
    'derapata',
    'derivare',
    'deroga',
    'descritto',
    'deserto',
    'desiderio',
    'desumere',
    'detersivo',
    'devoto',
    'diametro',
    'dicembre',
    'diedro',
    'difeso',
    'diffuso',
    'digerire',
    'digitale',
    'diluvio',
    'dinamico',
    'dinnanzi',
    'dipinto',
    'diploma',
    'dipolo',
    'diradare',
    'dire',
    'dirotto',
    'dirupo',
    'disagio',
    'discreto',
    'disfare',
    'disgelo',
    'disposto',
    'distanza',
    'disumano',
    'dito',
    'divano',
    'divelto',
    'dividere',
    'divorato',
    'doblone',
    'docente',
    'doganale',
    'dogma',
    'dolce',
    'domato',
    'domenica',
    'dominare',
    'dondolo',
    'dono',
    'dormire',
    'dote',
    'dottore',
    'dovuto',
    'dozzina',
    'drago',
    'druido',
    'dubbio',
    'dubitare',
    'ducale',
    'duna',
    'duomo',
    'duplice',
    'duraturo',
    'ebano',
    'eccesso',
    'ecco',
    'eclissi',
    'economia',
    'edera',
    'edicola',
    'edile',
    'editoria',
    'educare',
    'egemonia',
    'egli',
    'egoismo',
    'egregio',
    'elaborato',
    'elargire',
    'elegante',
    'elencato',
    'eletto',
    'elevare',
    'elfico',
    'elica',
    'elmo',
    'elsa',
    'eluso',
    'emanato',
    'emblema',
    'emesso',
    'emiro',
    'emotivo',
    'emozione',
    'empirico',
    'emulo',
    'endemico',
    'enduro',
    'energia',
    'enfasi',
    'enoteca',
    'entrare',
    'enzima',
    'epatite',
    'epilogo',
    'episodio',
    'epocale',
    'eppure',
    'equatore',
    'erario',
    'erba',
    'erboso',
    'erede',
    'eremita',
    'erigere',
    'ermetico',
    'eroe',
    'erosivo',
    'errante',
    'esagono',
    'esame',
    'esanime',
    'esaudire',
    'esca',
    'esempio',
    'esercito',
    'esibito',
    'esigente',
    'esistere',
    'esito',
    'esofago',
    'esortato',
    'esoso',
    'espanso',
    'espresso',
    'essenza',
    'esso',
    'esteso',
    'estimare',
    'estonia',
    'estroso',
    'esultare',
    'etilico',
    'etnico',
    'etrusco',
    'etto',
    'euclideo',
    'europa',
    'evaso',
    'evidenza',
    'evitato',
    'evoluto',
    'evviva',
    'fabbrica',
    'faccenda',
    'fachiro',
    'falco',
    'famiglia',
    'fanale',
    'fanfara',
    'fango',
    'fantasma',
    'fare',
    'farfalla',
    'farinoso',
    'farmaco',
    'fascia',
    'fastoso',
    'fasullo',
    'faticare',
    'fato',
    'favoloso',
    'febbre',
    'fecola',
    'fede',
    'fegato',
    'felpa',
    'feltro',
    'femmina',
    'fendere',
    'fenomeno',
    'fermento',
    'ferro',
    'fertile',
    'fessura',
    'festivo',
    'fetta',
    'feudo',
    'fiaba',
    'fiducia',
    'fifa',
    'figurato',
    'filo',
    'finanza',
    'finestra',
    'finire',
    'fiore',
    'fiscale',
    'fisico',
    'fiume',
    'flacone',
    'flamenco',
    'flebo',
    'flemma',
    'florido',
    'fluente',
    'fluoro',
    'fobico',
    'focaccia',
    'focoso',
    'foderato',
    'foglio',
    'folata',
    'folclore',
    'folgore',
    'fondente',
    'fonetico',
    'fonia',
    'fontana',
    'forbito',
    'forchetta',
    'foresta',
    'formica',
    'fornaio',
    'foro',
    'fortezza',
    'forzare',
    'fosfato',
    'fosso',
    'fracasso',
    'frana',
    'frassino',
    'fratello',
    'freccetta',
    'frenata',
    'fresco',
    'frigo',
    'frollino',
    'fronde',
    'frugale',
    'frutta',
    'fucilata',
    'fucsia',
    'fuggente',
    'fulmine',
    'fulvo',
    'fumante',
    'fumetto',
    'fumoso',
    'fune',
    'funzione',
    'fuoco',
    'furbo',
    'furgone',
    'furore',
    'fuso',
    'futile',
    'gabbiano',
    'gaffe',
    'galateo',
    'gallina',
    'galoppo',
    'gambero',
    'gamma',
    'garanzia',
    'garbo',
    'garofano',
    'garzone',
    'gasdotto',
    'gasolio',
    'gastrico',
    'gatto',
    'gaudio',
    'gazebo',
    'gazzella',
    'geco',
    'gelatina',
    'gelso',
    'gemello',
    'gemmato',
    'gene',
    'genitore',
    'gennaio',
    'genotipo',
    'gergo',
    'ghepardo',
    'ghiaccio',
    'ghisa',
    'giallo',
    'gilda',
    'ginepro',
    'giocare',
    'gioiello',
    'giorno',
    'giove',
    'girato',
    'girone',
    'gittata',
    'giudizio',
    'giurato',
    'giusto',
    'globulo',
    'glutine',
    'gnomo',
    'gobba',
    'golf',
    'gomito',
    'gommone',
    'gonfio',
    'gonna',
    'governo',
    'gracile',
    'grado',
    'grafico',
    'grammo',
    'grande',
    'grattare',
    'gravoso',
    'grazia',
    'greca',
    'gregge',
    'grifone',
    'grigio',
    'grinza',
    'grotta',
    'gruppo',
    'guadagno',
    'guaio',
    'guanto',
    'guardare',
    'gufo',
    'guidare',
    'ibernato',
    'icona',
    'identico',
    'idillio',
    'idolo',
    'idra',
    'idrico',
    'idrogeno',
    'igiene',
    'ignaro',
    'ignorato',
    'ilare',
    'illeso',
    'illogico',
    'illudere',
    'imballo',
    'imbevuto',
    'imbocco',
    'imbuto',
    'immane',
    'immerso',
    'immolato',
    'impacco',
    'impeto',
    'impiego',
    'importo',
    'impronta',
    'inalare',
    'inarcare',
    'inattivo',
    'incanto',
    'incendio',
    'inchino',
    'incisivo',
    'incluso',
    'incontro',
    'incrocio',
    'incubo',
    'indagine',
    'india',
    'indole',
    'inedito',
    'infatti',
    'infilare',
    'inflitto',
    'ingaggio',
    'ingegno',
    'inglese',
    'ingordo',
    'ingrosso',
    'innesco',
    'inodore',
    'inoltrare',
    'inondato',
    'insano',
    'insetto',
    'insieme',
    'insonnia',
    'insulina',
    'intasato',
    'intero',
    'intonaco',
    'intuito',
    'inumidire',
    'invalido',
    'invece',
    'invito',
    'iperbole',
    'ipnotico',
    'ipotesi',
    'ippica',
    'iride',
    'irlanda',
    'ironico',
    'irrigato',
    'irrorare',
    'isolato',
    'isotopo',
    'isterico',
    'istituto',
    'istrice',
    'italia',
    'iterare',
    'labbro',
    'labirinto',
    'lacca',
    'lacerato',
    'lacrima',
    'lacuna',
    'laddove',
    'lago',
    'lampo',
    'lancetta',
    'lanterna',
    'lardoso',
    'larga',
    'laringe',
    'lastra',
    'latenza',
    'latino',
    'lattuga',
    'lavagna',
    'lavoro',
    'legale',
    'leggero',
    'lembo',
    'lentezza',
    'lenza',
    'leone',
    'lepre',
    'lesivo',
    'lessato',
    'lesto',
    'letterale',
    'leva',
    'levigato',
    'libero',
    'lido',
    'lievito',
    'lilla',
    'limatura',
    'limitare',
    'limpido',
    'lineare',
    'lingua',
    'liquido',
    'lira',
    'lirica',
    'lisca',
    'lite',
    'litigio',
    'livrea',
    'locanda',
    'lode',
    'logica',
    'lombare',
    'londra',
    'longevo',
    'loquace',
    'lorenzo',
    'loto',
    'lotteria',
    'luce',
    'lucidato',
    'lumaca',
    'luminoso',
    'lungo',
    'lupo',
    'luppolo',
    'lusinga',
    'lusso',
    'lutto',
    'macabro',
    'macchina',
    'macero',
    'macinato',
    'madama',
    'magico',
    'maglia',
    'magnete',
    'magro',
    'maiolica',
    'malafede',
    'malgrado',
    'malinteso',
    'malsano',
    'malto',
    'malumore',
    'mana',
    'mancia',
    'mandorla',
    'mangiare',
    'manifesto',
    'mannaro',
    'manovra',
    'mansarda',
    'mantide',
    'manubrio',
    'mappa',
    'maratona',
    'marcire',
    'maretta',
    'marmo',
    'marsupio',
    'maschera',
    'massaia',
    'mastino',
    'materasso',
    'matricola',
    'mattone',
    'maturo',
    'mazurca',
    'meandro',
    'meccanico',
    'mecenate',
    'medesimo',
    'meditare',
    'mega',
    'melassa',
    'melis',
    'melodia',
    'meninge',
    'meno',
    'mensola',
    'mercurio',
    'merenda',
    'merlo',
    'meschino',
    'mese',
    'messere',
    'mestolo',
    'metallo',
    'metodo',
    'mettere',
    'miagolare',
    'mica',
    'micelio',
    'michele',
    'microbo',
    'midollo',
    'miele',
    'migliore',
    'milano',
    'milite',
    'mimosa',
    'minerale',
    'mini',
    'minore',
    'mirino',
    'mirtillo',
    'miscela',
    'missiva',
    'misto',
    'misurare',
    'mitezza',
    'mitigare',
    'mitra',
    'mittente',
    'mnemonico',
    'modello',
    'modifica',
    'modulo',
    'mogano',
    'mogio',
    'mole',
    'molosso',
    'monastero',
    'monco',
    'mondina',
    'monetario',
    'monile',
    'monotono',
    'monsone',
    'montato',
    'monviso',
    'mora',
    'mordere',
    'morsicato',
    'mostro',
    'motivato',
    'motosega',
    'motto',
    'movenza',
    'movimento',
    'mozzo',
    'mucca',
    'mucosa',
    'muffa',
    'mughetto',
    'mugnaio',
    'mulatto',
    'mulinello',
    'multiplo',
    'mummia',
    'munto',
    'muovere',
    'murale',
    'musa',
    'muscolo',
    'musica',
    'mutevole',
    'muto',
    'nababbo',
    'nafta',
    'nanometro',
    'narciso',
    'narice',
    'narrato',
    'nascere',
    'nastrare',
    'naturale',
    'nautica',
    'naviglio',
    'nebulosa',
    'necrosi',
    'negativo',
    'negozio',
    'nemmeno',
    'neofita',
    'neretto',
    'nervo',
    'nessuno',
    'nettuno',
    'neutrale',
    'neve',
    'nevrotico',
    'nicchia',
    'ninfa',
    'nitido',
    'nobile',
    'nocivo',
    'nodo',
    'nome',
    'nomina',
    'nordico',
    'normale',
    'norvegese',
    'nostrano',
    'notare',
    'notizia',
    'notturno',
    'novella',
    'nucleo',
    'nulla',
    'numero',
    'nuovo',
    'nutrire',
    'nuvola',
    'nuziale',
    'oasi',
    'obbedire',
    'obbligo',
    'obelisco',
    'oblio',
    'obolo',
    'obsoleto',
    'occasione',
    'occhio',
    'occidente',
    'occorrere',
    'occultare',
    'ocra',
    'oculato',
    'odierno',
    'odorare',
    'offerta',
    'offrire',
    'offuscato',
    'oggetto',
    'oggi',
    'ognuno',
    'olandese',
    'olfatto',
    'oliato',
    'oliva',
    'ologramma',
    'oltre',
    'omaggio',
    'ombelico',
    'ombra',
    'omega',
    'omissione',
    'ondoso',
    'onere',
    'onice',
    'onnivoro',
    'onorevole',
    'onta',
    'operato',
    'opinione',
    'opposto',
    'oracolo',
    'orafo',
    'ordine',
    'orecchino',
    'orefice',
    'orfano',
    'organico',
    'origine',
    'orizzonte',
    'orma',
    'ormeggio',
    'ornativo',
    'orologio',
    'orrendo',
    'orribile',
    'ortensia',
    'ortica',
    'orzata',
    'orzo',
    'osare',
    'oscurare',
    'osmosi',
    'ospedale',
    'ospite',
    'ossa',
    'ossidare',
    'ostacolo',
    'oste',
    'otite',
    'otre',
    'ottagono',
    'ottimo',
    'ottobre',
    'ovale',
    'ovest',
    'ovino',
    'oviparo',
    'ovocito',
    'ovunque',
    'ovviare',
    'ozio',
    'pacchetto',
    'pace',
    'pacifico',
    'padella',
    'padrone',
    'paese',
    'paga',
    'pagina',
    'palazzina',
    'palesare',
    'pallido',
    'palo',
    'palude',
    'pandoro',
    'pannello',
    'paolo',
    'paonazzo',
    'paprica',
    'parabola',
    'parcella',
    'parere',
    'pargolo',
    'pari',
    'parlato',
    'parola',
    'partire',
    'parvenza',
    'parziale',
    'passivo',
    'pasticca',
    'patacca',
    'patologia',
    'pattume',
    'pavone',
    'peccato',
    'pedalare',
    'pedonale',
    'peggio',
    'peloso',
    'penare',
    'pendice',
    'penisola',
    'pennuto',
    'penombra',
    'pensare',
    'pentola',
    'pepe',
    'pepita',
    'perbene',
    'percorso',
    'perdonato',
    'perforare',
    'pergamena',
    'periodo',
    'permesso',
    'perno',
    'perplesso',
    'persuaso',
    'pertugio',
    'pervaso',
    'pesatore',
    'pesista',
    'peso',
    'pestifero',
    'petalo',
    'pettine',
    'petulante',
    'pezzo',
    'piacere',
    'pianta',
    'piattino',
    'piccino',
    'picozza',
    'piega',
    'pietra',
    'piffero',
    'pigiama',
    'pigolio',
    'pigro',
    'pila',
    'pilifero',
    'pillola',
    'pilota',
    'pimpante',
    'pineta',
    'pinna',
    'pinolo',
    'pioggia',
    'piombo',
    'piramide',
    'piretico',
    'pirite',
    'pirolisi',
    'pitone',
    'pizzico',
    'placebo',
    'planare',
    'plasma',
    'platano',
    'plenario',
    'pochezza',
    'poderoso',
    'podismo',
    'poesia',
    'poggiare',
    'polenta',
    'poligono',
    'pollice',
    'polmonite',
    'polpetta',
    'polso',
    'poltrona',
    'polvere',
    'pomice',
    'pomodoro',
    'ponte',
    'popoloso',
    'porfido',
    'poroso',
    'porpora',
    'porre',
    'portata',
    'posa',
    'positivo',
    'possesso',
    'postulato',
    'potassio',
    'potere',
    'pranzo',
    'prassi',
    'pratica',
    'precluso',
    'predica',
    'prefisso',
    'pregiato',
    'prelievo',
    'premere',
    'prenotare',
    'preparato',
    'presenza',
    'pretesto',
    'prevalso',
    'prima',
    'principe',
    'privato',
    'problema',
    'procura',
    'produrre',
    'profumo',
    'progetto',
    'prolunga',
    'promessa',
    'pronome',
    'proposta',
    'proroga',
    'proteso',
    'prova',
    'prudente',
    'prugna',
    'prurito',
    'psiche',
    'pubblico',
    'pudica',
    'pugilato',
    'pugno',
    'pulce',
    'pulito',
    'pulsante',
    'puntare',
    'pupazzo',
    'pupilla',
    'puro',
    'quadro',
    'qualcosa',
    'quasi',
    'querela',
    'quota',
    'raccolto',
    'raddoppio',
    'radicale',
    'radunato',
    'raffica',
    'ragazzo',
    'ragione',
    'ragno',
    'ramarro',
    'ramingo',
    'ramo',
    'randagio',
    'rantolare',
    'rapato',
    'rapina',
    'rappreso',
    'rasatura',
    'raschiato',
    'rasente',
    'rassegna',
    'rastrello',
    'rata',
    'ravveduto',
    'reale',
    'recepire',
    'recinto',
    'recluta',
    'recondito',
    'recupero',
    'reddito',
    'redimere',
    'regalato',
    'registro',
    'regola',
    'regresso',
    'relazione',
    'remare',
    'remoto',
    'renna',
    'replica',
    'reprimere',
    'reputare',
    'resa',
    'residente',
    'responso',
    'restauro',
    'rete',
    'retina',
    'retorica',
    'rettifica',
    'revocato',
    'riassunto',
    'ribadire',
    'ribelle',
    'ribrezzo',
    'ricarica',
    'ricco',
    'ricevere',
    'riciclato',
    'ricordo',
    'ricreduto',
    'ridicolo',
    'ridurre',
    'rifasare',
    'riflesso',
    'riforma',
    'rifugio',
    'rigare',
    'rigettato',
    'righello',
    'rilassato',
    'rilevato',
    'rimanere',
    'rimbalzo',
    'rimedio',
    'rimorchio',
    'rinascita',
    'rincaro',
    'rinforzo',
    'rinnovo',
    'rinomato',
    'rinsavito',
    'rintocco',
    'rinuncia',
    'rinvenire',
    'riparato',
    'ripetuto',
    'ripieno',
    'riportare',
    'ripresa',
    'ripulire',
    'risata',
    'rischio',
    'riserva',
    'risibile',
    'riso',
    'rispetto',
    'ristoro',
    'risultato',
    'risvolto',
    'ritardo',
    'ritegno',
    'ritmico',
    'ritrovo',
    'riunione',
    'riva',
    'riverso',
    'rivincita',
    'rivolto',
    'rizoma',
    'roba',
    'robotico',
    'robusto',
    'roccia',
    'roco',
    'rodaggio',
    'rodere',
    'roditore',
    'rogito',
    'rollio',
    'romantico',
    'rompere',
    'ronzio',
    'rosolare',
    'rospo',
    'rotante',
    'rotondo',
    'rotula',
    'rovescio',
    'rubizzo',
    'rubrica',
    'ruga',
    'rullino',
    'rumine',
    'rumoroso',
    'ruolo',
    'rupe',
    'russare',
    'rustico',
    'sabato',
    'sabbiare',
    'sabotato',
    'sagoma',
    'salasso',
    'saldatura',
    'salgemma',
    'salivare',
    'salmone',
    'salone',
    'saltare',
    'saluto',
    'salvo',
    'sapere',
    'sapido',
    'saporito',
    'saraceno',
    'sarcasmo',
    'sarto',
    'sassoso',
    'satellite',
    'satira',
    'satollo',
    'saturno',
    'savana',
    'savio',
    'saziato',
    'sbadiglio',
    'sbalzo',
    'sbancato',
    'sbarra',
    'sbattere',
    'sbavare',
    'sbendare',
    'sbirciare',
    'sbloccato',
    'sbocciato',
    'sbrinare',
    'sbruffone',
    'sbuffare',
    'scabroso',
    'scadenza',
    'scala',
    'scambiare',
    'scandalo',
    'scapola',
    'scarso',
    'scatenare',
    'scavato',
    'scelto',
    'scenico',
    'scettro',
    'scheda',
    'schiena',
    'sciarpa',
    'scienza',
    'scindere',
    'scippo',
    'sciroppo',
    'scivolo',
    'sclerare',
    'scodella',
    'scolpito',
    'scomparto',
    'sconforto',
    'scoprire',
    'scorta',
    'scossone',
    'scozzese',
    'scriba',
    'scrollare',
    'scrutinio',
    'scuderia',
    'scultore',
    'scuola',
    'scuro',
    'scusare',
    'sdebitare',
    'sdoganare',
    'seccatura',
    'secondo',
    'sedano',
    'seggiola',
    'segnalato',
    'segregato',
    'seguito',
    'selciato',
    'selettivo',
    'sella',
    'selvaggio',
    'semaforo',
    'sembrare',
    'seme',
    'seminato',
    'sempre',
    'senso',
    'sentire',
    'sepolto',
    'sequenza',
    'serata',
    'serbato',
    'sereno',
    'serio',
    'serpente',
    'serraglio',
    'servire',
    'sestina',
    'setola',
    'settimana',
    'sfacelo',
    'sfaldare',
    'sfamato',
    'sfarzoso',
    'sfaticato',
    'sfera',
    'sfida',
    'sfilato',
    'sfinge',
    'sfocato',
    'sfoderare',
    'sfogo',
    'sfoltire',
    'sforzato',
    'sfratto',
    'sfruttato',
    'sfuggito',
    'sfumare',
    'sfuso',
    'sgabello',
    'sgarbato',
    'sgonfiare',
    'sgorbio',
    'sgrassato',
    'sguardo',
    'sibilo',
    'siccome',
    'sierra',
    'sigla',
    'signore',
    'silenzio',
    'sillaba',
    'simbolo',
    'simpatico',
    'simulato',
    'sinfonia',
    'singolo',
    'sinistro',
    'sino',
    'sintesi',
    'sinusoide',
    'sipario',
    'sisma',
    'sistole',
    'situato',
    'slitta',
    'slogatura',
    'sloveno',
    'smarrito',
    'smemorato',
    'smentito',
    'smeraldo',
    'smilzo',
    'smontare',
    'smottato',
    'smussato',
    'snellire',
    'snervato',
    'snodo',
    'sobbalzo',
    'sobrio',
    'soccorso',
    'sociale',
    'sodale',
    'soffitto',
    'sogno',
    'soldato',
    'solenne',
    'solido',
    'sollazzo',
    'solo',
    'solubile',
    'solvente',
    'somatico',
    'somma',
    'sonda',
    'sonetto',
    'sonnifero',
    'sopire',
    'soppeso',
    'sopra',
    'sorgere',
    'sorpasso',
    'sorriso',
    'sorso',
    'sorteggio',
    'sorvolato',
    'sospiro',
    'sosta',
    'sottile',
    'spada',
    'spalla',
    'spargere',
    'spatola',
    'spavento',
    'spazzola',
    'specie',
    'spedire',
    'spegnere',
    'spelatura',
    'speranza',
    'spessore',
    'spettrale',
    'spezzato',
    'spia',
    'spigoloso',
    'spillato',
    'spinoso',
    'spirale',
    'splendido',
    'sportivo',
    'sposo',
    'spranga',
    'sprecare',
    'spronato',
    'spruzzo',
    'spuntino',
    'squillo',
    'sradicare',
    'srotolato',
    'stabile',
    'stacco',
    'staffa',
    'stagnare',
    'stampato',
    'stantio',
    'starnuto',
    'stasera',
    'statuto',
    'stelo',
    'steppa',
    'sterzo',
    'stiletto',
    'stima',
    'stirpe',
    'stivale',
    'stizzoso',
    'stonato',
    'storico',
    'strappo',
    'stregato',
    'stridulo',
    'strozzare',
    'strutto',
    'stuccare',
    'stufo',
    'stupendo',
    'subentro',
    'succoso',
    'sudore',
    'suggerito',
    'sugo',
    'sultano',
    'suonare',
    'superbo',
    'supporto',
    'surgelato',
    'surrogato',
    'sussurro',
    'sutura',
    'svagare',
    'svedese',
    'sveglio',
    'svelare',
    'svenuto',
    'svezia',
    'sviluppo',
    'svista',
    'svizzera',
    'svolta',
    'svuotare',
    'tabacco',
    'tabulato',
    'tacciare',
    'taciturno',
    'tale',
    'talismano',
    'tampone',
    'tannino',
    'tara',
    'tardivo',
    'targato',
    'tariffa',
    'tarpare',
    'tartaruga',
    'tasto',
    'tattico',
    'taverna',
    'tavolata',
    'tazza',
    'teca',
    'tecnico',
    'telefono',
    'temerario',
    'tempo',
    'temuto',
    'tendone',
    'tenero',
    'tensione',
    'tentacolo',
    'teorema',
    'terme',
    'terrazzo',
    'terzetto',
    'tesi',
    'tesserato',
    'testato',
    'tetro',
    'tettoia',
    'tifare',
    'tigella',
    'timbro',
    'tinto',
    'tipico',
    'tipografo',
    'tiraggio',
    'tiro',
    'titanio',
    'titolo',
    'titubante',
    'tizio',
    'tizzone',
    'toccare',
    'tollerare',
    'tolto',
    'tombola',
    'tomo',
    'tonfo',
    'tonsilla',
    'topazio',
    'topologia',
    'toppa',
    'torba',
    'tornare',
    'torrone',
    'tortora',
    'toscano',
    'tossire',
    'tostatura',
    'totano',
    'trabocco',
    'trachea',
    'trafila',
    'tragedia',
    'tralcio',
    'tramonto',
    'transito',
    'trapano',
    'trarre',
    'trasloco',
    'trattato',
    'trave',
    'treccia',
    'tremolio',
    'trespolo',
    'tributo',
    'tricheco',
    'trifoglio',
    'trillo',
    'trincea',
    'trio',
    'tristezza',
    'triturato',
    'trivella',
    'tromba',
    'trono',
    'troppo',
    'trottola',
    'trovare',
    'truccato',
    'tubatura',
    'tuffato',
    'tulipano',
    'tumulto',
    'tunisia',
    'turbare',
    'turchino',
    'tuta',
    'tutela',
    'ubicato',
    'uccello',
    'uccisore',
    'udire',
    'uditivo',
    'uffa',
    'ufficio',
    'uguale',
    'ulisse',
    'ultimato',
    'umano',
    'umile',
    'umorismo',
    'uncinetto',
    'ungere',
    'ungherese',
    'unicorno',
    'unificato',
    'unisono',
    'unitario',
    'unte',
    'uovo',
    'upupa',
    'uragano',
    'urgenza',
    'urlo',
    'usanza',
    'usato',
    'uscito',
    'usignolo',
    'usuraio',
    'utensile',
    'utilizzo',
    'utopia',
    'vacante',
    'vaccinato',
    'vagabondo',
    'vagliato',
    'valanga',
    'valgo',
    'valico',
    'valletta',
    'valoroso',
    'valutare',
    'valvola',
    'vampata',
    'vangare',
    'vanitoso',
    'vano',
    'vantaggio',
    'vanvera',
    'vapore',
    'varano',
    'varcato',
    'variante',
    'vasca',
    'vedetta',
    'vedova',
    'veduto',
    'vegetale',
    'veicolo',
    'velcro',
    'velina',
    'velluto',
    'veloce',
    'venato',
    'vendemmia',
    'vento',
    'verace',
    'verbale',
    'vergogna',
    'verifica',
    'vero',
    'verruca',
    'verticale',
    'vescica',
    'vessillo',
    'vestale',
    'veterano',
    'vetrina',
    'vetusto',
    'viandante',
    'vibrante',
    'vicenda',
    'vichingo',
    'vicinanza',
    'vidimare',
    'vigilia',
    'vigneto',
    'vigore',
    'vile',
    'villano',
    'vimini',
    'vincitore',
    'viola',
    'vipera',
    'virgola',
    'virologo',
    'virulento',
    'viscoso',
    'visione',
    'vispo',
    'vissuto',
    'visura',
    'vita',
    'vitello',
    'vittima',
    'vivanda',
    'vivido',
    'viziare',
    'voce',
    'voga',
    'volatile',
    'volere',
    'volpe',
    'voragine',
    'vulcano',
    'zampogna',
    'zanna',
    'zappato',
    'zattera',
    'zavorra',
    'zefiro',
    'zelante',
    'zelo',
    'zenzero',
    'zerbino',
    'zibetto',
    'zinco',
    'zircone',
    'zitto',
    'zolla',
    'zotico',
    'zucchero',
    'zufolo',
    'zulu',
    'zuppa'
];
//# sourceMappingURL=italian.js.map